export enum ComponentInstanceType {
	Component = 'component',
	Components = 'components',
	ComponentCategory = 'componentCategory',
	ComponentCategories = 'componentCategories',
	ComponentVendor = 'componentVendor',
	ComponentVendors = 'componentVendors'
}

export type ComponentInstanceTypes = typeof ComponentInstanceType;
